import { useQuery } from 'react-query';
import apiCalls from '../../utils/apiCalls';

export function useMarketplaces() {
  const { data, ...rest } = useQuery(['marketplaces'], () =>
    apiCalls.getMarketplaces().then(({ data: { marketplaces } }) => marketplaces)
  );
  return { marketplaces: data, ...rest };
}

export function useCombinedOrderItems({ deliveryDayMarketplaceId }) {
  const { data, ...rest } = useQuery(
    ['combinedOrderItems', { deliveryDayMarketplaceId }],
    () =>
      apiCalls
        .getCombinedOrderItems({ deliveryDayMarketplaceId })
        .then(({ data: { combinedOrderItems } }) => combinedOrderItems),
    {
      enabled: !!deliveryDayMarketplaceId,
    }
  );
  return { combinedOrderItems: data, ...rest };
}

export function useDeliveryDayMarketplaces({ marketplaceId, deliveryDayIds }) {
  const { data, ...rest } = useQuery(
    ['deliveryDayMarketplaces', { marketplaceId, deliveryDayIds }],
    () =>
      apiCalls
        .getDeliveryDayMarketplaces({ marketplaceId, deliveryDayIds, includeCombinedOrderItems: true, showPast: true })
        .then(({ data: { deliveryDayMarketplaces } }) => deliveryDayMarketplaces),
    {
      enabled: !!marketplaceId && !!deliveryDayIds,
    }
  );
  return { deliveryDayMarketplaces: data, ...rest };
}

export function useDeliveryDays(params) {
  const { data, ...rest } = useQuery(['deliveryDays', params], () =>
    apiCalls.getDeliveryDays(params).then(({ data: { deliveryDays } }) => deliveryDays)
  );
  return { deliveryDays: data, ...rest };
}
